import { Controller } from '@hotwired/stimulus'
import ApexCharts from 'apexcharts'

export default class extends Controller {
  static values = { data: Number, name: String }

  connect() {
    this.initializeChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  initializeChart() {
    if (this.chart) {
      this.chart.destroy()
    }
    const options = {
      chart: {
        height: 280,
        width: 280,
        type: 'radialBar',
        sparkline: {
          enabled: false,
        },
      },
      series: [this.dataValue],
      colors: ['#eab308'], // cor base
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              fontSize: '32px',
              fontWeight: 'bold',
              show: true,
              formatter: function (val) {
                return val + '%'
              },
              offsetY: 5,
            },
          },
          track: {
            background: '#f3f4f6',
            strokeWidth: '10px',
          },
          hollow: {
            size: '60%',
          },
        },
      },
      fill: {
        type: 'solid',
        colors: ['#FFDE45'],
      },
      stroke: {
        lineCap: 'round',
        width: 10,
      },
      states: {
        hover: {
          filter: {
            type: 'none',
          },
        },
      },
    }

    this.chart = new ApexCharts(document.querySelector('#radial-chart'), options)
    this.chart.render()
  }
}
